import React, { useState } from "react";
import axios from "axios";

const DeepLinkTool = ({ backEndUrl, encodedState }) => {
    const [selectedItems, setSelectedItems] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState(null);

    // Static items for selection
    const items = Array.from({ length: 10 }, (_, i) => `LTI Assignment ${i + 1}`);

    const handleCheckboxChange = (event) => {
        const item = event.target.value;

        setSelectedItems((prevSelectedItems) => {
            if (event.target.checked) {
                return [...prevSelectedItems, item];
            } else {
                return prevSelectedItems.filter((i) => i !== item);
            }
        });
    };

    const handleDeploy = async () => {
        if (selectedItems.length === 0) {
            setMessage("Please select at least one item to deploy.");
            return;
        }

        const payload = {
            selectedItems: selectedItems.map((item) => ({
                type: "ltiResourceLink",
                title: item,
                url: `${backEndUrl}/lti/launch/${item.replace(/\s+/g, "-").toLowerCase()}`,
                custom: {
                    assignmentName: item,
                    route: "LTIAssignment"
                },
            })),
        };

        try {
            setIsLoading(true);
            setMessage(null);

            // Post to the backend to get the JWT
            const backendResponse = await axios.post(`${backEndUrl}/lti/deep-link?state=${encodedState}`, payload, {
                headers: {
                    "Content-Type": "application/json"
                },
            });

            const jwt = backendResponse.data.jwt;
            if (!jwt) {
                throw new Error("No JWT received from backend.");
            }

            // Create a form to post the JWT to the deep link return URL
            const form = document.createElement("form");
            form.method = "POST";
            form.action = backendResponse.data.deepLinkReturnUrl; // Ensure this is included in the backend response
            form.enctype = "application/x-www-form-urlencoded"; // Add enctype for proper encoding

            const input = document.createElement("input");
            input.type = "hidden";
            input.name = "JWT";
            input.value = jwt;

            form.appendChild(input);
            document.body.appendChild(form);

            form.submit();
        } catch (error) {
            console.error("Deployment failed:", error);
            setMessage("Deployment failed. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="deep-link-tool-container">
            <h1>Deep Link Tool</h1>
            {message && <div className="message">{message}</div>}
            <div className="item-list">
                {items.map((item, index) => (
                    <div key={index} className="item">
                        <input
                            type="checkbox"
                            value={item}
                            onChange={handleCheckboxChange}
                        />
                        <label>{item}</label>
                    </div>
                ))}
            </div>
            <button onClick={handleDeploy} className="deploy-button" disabled={isLoading}>
                {isLoading ? "Deploying..." : "Deploy to Blackboard"}
            </button>
        </div>
    );
};

export default DeepLinkTool;
